import React from "react";

import {Modal} from "@mantine/core";

const ConfirmModal = (props) => {
	return (
		<Modal
			title={props.title}
			opened={props.opened}
			centered={true}
			radius="xl"
			styles={{
				title: {margin: "auto", fontWeight: "bold", fontSize: "16px"},
				body: {fontWeight: "lighter"},
			}}
			onClose={() => props.onCancel()}
		>
			<div className={"flex flex-col"}>
				{props.message ? (
					<p className={"text-center font-normal"}>{props.message}</p>
				) : null}
				<div className={"flex justify-center gap-3 mt-5"}>
					<button
						type="button"
						onClick={() => props.onConfirm()}
						className={
							"bg-green text-white rounded-3xl px-10 py-2 self-center"
						}
					>
						{props.confirmLabel}
					</button>
					<button
						type="button"
						onClick={() => props.onCancel()}
						className={
							"bg-gray text-white rounded-3xl px-10 py-2 self-center"
						}
					>
						{props.cancelLabel}
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default ConfirmModal;
